import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import HomeTwo from './HomeTwo'
import About from './About'
import LoadTop from '../Components/LoadTop'
import Destination from './Destination'
import DestinationDetails from './DestinationDetails'
import Service from './Service'
import ServiceDetails from './ServiceDetails';
import Activities from './Activities'
import ActivitiesDetails from './ActivitiesDetails'
import Gallery from './Gallery'
import Tour from './Tour'
import TourDetails from './TourDetails'
import TourGuide from './TourGuide'
import TourGuiderDetails from './TourGuiderDetails'
import Faq from './Faq'
import Pricing from './Pricing'
import Error from './Error'
import Blog from './Blog'
import BlogDetails from './BlogDetails'
import Contact from './Contact'
import TermsConditions from './TermsConditions'
import PrivacyPolicy from './PrivacyPolicy'
import AdminLogin from './AdminLogin'
import AdminDashboard from './AdminDashboard'
function RouterPage() {
  return (
    <div>
      <Router basename={process.env.PUBLIC_URL || '/'}>
        <LoadTop />
        <Routes>
          <Route path="/" element={<HomeTwo />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/destination" element={<Destination />}></Route>
          <Route path="/destination/:id" element={<DestinationDetails />} />
          <Route path="/service" element={<Service />}></Route>
          <Route path="/service/:slug" element={<ServiceDetails />} />
          <Route path="/activities" element={<Activities />}></Route>
          <Route path="/activities-details" element={<ActivitiesDetails />}></Route>
          <Route path="/gallery" element={<Gallery />}></Route>
          <Route path="/tour" element={<Tour />}></Route>
          <Route path="/tour/:slug" element={<TourDetails />}></Route>
          <Route path="/tour-guide" element={<TourGuide />}></Route>
          <Route path="/tour-guide/:id" element={<TourGuiderDetails />}></Route>
          <Route path="/faq" element={<Faq />}></Route>
          <Route path="/price" element={<Pricing />}></Route>
          <Route path="/error" element={<Error />}></Route>
          <Route path="/blog" element={<Blog />}></Route>
          <Route path="/blog/:slug" element={<BlogDetails />}></Route>
          <Route path="/terms-and-conditions" element={<TermsConditions />}></Route>
          <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
          <Route path="/contact" element={<Contact />}></Route> 
          <Route path="/admin/login" element={<AdminLogin />}></Route>
          <Route path="/admin" element={<AdminDashboard />}></Route>
        </Routes>
      </Router>
    </div>
  )
}

export default RouterPage